import { Injectable } from '@angular/core';
import { LocationService } from '../../../../../../data-services/location.service';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataFilterDisplayService } from '../../interface';
import { TranslateService } from '@ngx-translate/core';
import DOMPurify from 'dompurify';

@Injectable({ providedIn: 'root' })
export class LocationOptionsDisplayService implements DataFilterDisplayService {
  countryOptions$ = this.locationService.getCountries();
  constructor(private locationService: LocationService, private translate: TranslateService) {}

  getDisplay(value: string[]): Observable<string> {
    const countryRuleValue = value[0];
    const stateRuleValue = value[1];
    const cityRuleValue = value[2];
    const zipCodeRuleValue = value[3];

    const countryLabel$ = this.countryOptions$.pipe(
      map((countries) => {
        return countries.find((c) => c.code === countryRuleValue);
      }),
      map((country) => `<b>${country?.name}</b>`),
    );
    const stateLabel$ = this.locationService.getState(countryRuleValue, stateRuleValue).pipe(
      map((state) => {
        return `<b>${state?.name}</b>`;
      }),
    );

    return forkJoin([countryLabel$, stateLabel$]).pipe(
      map(([countryLabel, stateLabel]) => {
        let label = `${countryLabel}`;

        // For brevity, exclude wildcards in the display text.
        // Otherwise, include state and/or city names.
        if (stateRuleValue !== '*' && !!stateLabel) {
          label = `${stateLabel}, ` + label;
        }
        if (cityRuleValue !== '*' && !!cityRuleValue) {
          const sanitizedCity = DOMPurify.sanitize(cityRuleValue);
          const cityLabel = `<b>${sanitizedCity}</b>`;
          label = `${cityLabel}, ` + label;
        }

        if (zipCodeRuleValue !== '*' && !!zipCodeRuleValue) {
          const sanitizedZipCode = DOMPurify.sanitize(zipCodeRuleValue);
          const zipCodeLabel = `<b>${sanitizedZipCode}</b>`;
          label = `${zipCodeLabel}, ` + label;
        }

        return label;
      }),
    );
  }
}
